import { useState } from "react";
import Certificate from "../../../../../assets/Certificate.jpeg";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useColor } from '../../../../../components/ui/ColorContext';
import { Buttons } from '../../../../../components/ui/button';
import StarfieldCanvas from "./StartFeildCanvas";
import html2canvas from "html2canvas";
import { useRef } from "react";
import jsPDF from "jspdf";

export default function FinalCertificate({
  learnerPlayList,
  gameInfo,
  setCurrentScreenId,
}: any) {
 
const { primaryColor } = useColor();

const certificateRef = useRef<any>(null);
  // ✅ 1. Get Name
  const learnerName =
    gameInfo?.learnerDetails?.lenUserName ||
    learnerPlayList?.LearnerProfile?.name ||
    "Learner Name";

  // ✅ 2. Get Completion Date
  const questState = learnerPlayList?.questState || {};

  const allCompleted = Object.values(questState).every(
    (q: any) => q === "replayallowed"
  );

  const learnerId = learnerPlayList?.playerId;
  const gameId = learnerPlayList?.GameId;

  const storageKey = `completionDate_${learnerId}_${gameId}`;

  let completionDate = "";

  if (allCompleted) {
    const storedDate = localStorage.getItem(storageKey);

    if (storedDate) {
      completionDate = storedDate;
    } else {
      const newDate = new Date().toLocaleDateString();
      localStorage.setItem(storageKey, newDate);
      completionDate = newDate;
    }
  }
const [isDownloading,setIsDownloading]=useState(false)
  const downloadCertificate = async () => {
  if (!certificateRef.current) return;

  // ✅ clone UI
  const clone = certificateRef.current.cloneNode(true) as HTMLElement;

  // ✅ hide clone offscreen
  clone.style.position = "fixed";
  clone.style.top = "-9999px";
  clone.style.left = "-9999px";
  document.body.appendChild(clone);

  // ✅ fix date ONLY inside clone (no UI impact)
  const dateEl = clone.querySelector('.certificate-date') as HTMLElement;

  if (dateEl) {
    dateEl.style.top = "432px"; // 🔥 adjust ONLY for PDF
    dateEl.style.whiteSpace = "nowrap";
  }

  // ✅ wait for layout
  await new Promise(requestAnimationFrame);

  // ✅ capture clone
  const canvas = await html2canvas(clone, {
    scale: 2,
    useCORS: true,
  });

  // ✅ cleanup
  document.body.removeChild(clone);

  const imgData = canvas.toDataURL("image/png");

  // ✅ exact size PDF (no A4)
  const pdf = new jsPDF({
    orientation: "landscape",
    unit: "px",
    format: [canvas.width, canvas.height],
  });

  pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);

  pdf.save(`${learnerName}_Certificate.pdf`);
};


const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return "0, 255, 187"; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};

const NavigationArrow: React.FC<{
  direction: 'left' | 'right';
  onClick: () => void;
}> = ({ direction, onClick }) => {
  const { primaryColor } = useColor();
  return (
    <Buttons
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="h-10 w-[3.75rem] rounded-3xl px-4 py-2 transition-all duration-200 hover:scale-110"
      style={{
        background: `linear-gradient(${
          direction === 'left' ? '275.041deg' : '90deg'
        },
                rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(
          primaryColor,
        )}, 0.15) 84.803%)`,
        border: `1px solid ${primaryColor}`,
        boxShadow: `0px 0px 15.9542px 0px rgba(${hexToRgb(primaryColor)}, 0.3)`,
      }}
    >
      {direction === 'left' ? (
        <ChevronLeft className="!h-4 !w-4 text-white" />
      ) : (
        <ChevronRight className="!h-4 !w-4 text-white" />
      )}
    </Buttons>
  );
};




  // ✅ UI
  return (
 

  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
          width: "100%",
      flexDirection: "column",
      //  backgroundColor: primaryColor, 
    }}
  >
     <StarfieldCanvas />
      <div style={{ position: "absolute", left: "20px", top: "50%" }}>
    <NavigationArrow
      direction="left"
      onClick={() => setCurrentScreenId(21)} // 👈 go back
    />
  </div>
    <div
      ref={certificateRef}
      style={{
        position: "relative",
      
        width: "1152px" , height:"648px"
      }}
    >
      <img
        src={Certificate}
        alt="Certificate"
        // style={{ width: "1600px" , height:"720px"}}
        style={{
    width: "100%",
    height: "100%",
    display: "block",
  }}
      />

      <div
        style={{
          position: "absolute",
          top: "240px",
          left: "105px",
          fontSize: "28px",
          fontWeight: "bold",
          color: "#2F5597",
        }}
      >
        {learnerName}
      </div>

      <div
        style={{
          position: "absolute",
          // top: "442px",
          left: "140px",
            top: isDownloading?'410px':'410px',
          fontSize: "16px",
          color: "#000",
        }}
      >
        {completionDate}
      
      </div>



      
    </div>
      <div style={{ position: "absolute", right: "20px", top: "50%" }}>
    <NavigationArrow
      direction="right"
      onClick={() => setCurrentScreenId(19)} // next screen
    />
  </div>
<div
  style={{
    position: "absolute",
    bottom: "20px",
    right: "30px",
  }}
>
  <Buttons
    onClick={downloadCertificate}
    className="h-10 px-5 rounded-3xl transition-all duration-200 hover:scale-110"
    style={{
      background: `linear-gradient(90deg,
        rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%,
        rgba(${hexToRgb(primaryColor)}, 0.15) 84.803%)`,
      border: `1px solid ${primaryColor}`,
      boxShadow: `0px 0px 15.9542px 0px rgba(${hexToRgb(primaryColor)}, 0.3)`,
      color: "#fff",
    }}
  >
    Download Certificate
  </Buttons>
</div>
  </div>
);
}
